module.exports = __webpack_public_path__ + "static/media/WebDev-sm_1x.acd74c4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/WebDev/WebDev-sm_1x.jpg
// module id = 768
// module chunks = 0